import React from "react";
import "./carousel.css";
import videsh from "../../images/videsh01.png"
import videsh01 from "../../images/videsh02.png"
import videsh02 from "../../images/videsh03.png"
import videsh03 from "../../images/videsh04.png"
const items = [
  { title: "Air Cargo Freight", image:videsh},
  { title: "Special Cargo Shipping", image:videsh01},
  { title: "Charter & Project Cargo", image:videsh02},
  { title: "Sea Cargo Service", image:videsh03},
];

export default function ImageTextSlider() {
  return (
    <section className="section03 pb-0">
      <div className="marquee-container">
        <div className="marquee-track">
          {[...items, ...items].map((item, i) => (
            <div className="marquee-card  videsh-img" key={i}>
              <p className="">{item.title}</p>
              <div className="marquee-footer">
                <div className="marquee-content">
                  <img src={item.image} alt="" className="" />
                  {/* <div className="">
                    <h2>{item.name}</h2>
                    <p>{item.posi}</p>
                  </div> */}
                </div>
                {/* <img src={item.coma} alt="" /> */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
